<template>
  <div class="grid grid-cols-2 px-6 py-3 odd:bg-highlight rounded">
    <div class="mb-2 font-medium text-md text-text-secondary">{{ portfolioData.name }}</div>
    <div class="ml-auto font-medium text-md text-text" v-html="parseBalance"></div>
    <div class="text-text-muted text-xs"></div>
    <Indicator class="ml-auto" :changedValue="portfolioData.daily_change"/>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import Indicator from "@/components/cabinet/Money/Dashboard/MyInvestmentPortfolios/MyInvestmentPortfolioItem/Indicator";

export default {
  name: "MyInvestmentPortfolioItem",
  components: {Indicator},
  props: ['portfolioData'],
  computed: {
    ...mapGetters('cabinet/currencies', ['getCurrencyByCode', 'displayCurrencyValue']),
    parseBalance() {
      let currency = this.getCurrencyByCode(this.portfolioData.currency),
          formattedBalance = this.displayCurrencyValue(this.portfolioData.sum, currency, false),
          intPart = formattedBalance.split('.')[0],
          decimalPart = formattedBalance.split('.')[1];
      //splitting value to apply css rules
      return `${intPart}<span class="text-text-muted">.${decimalPart}</span> <span>${currency.symbol}</span>`
    }
  }
}
</script>

<style scoped>

</style>